import { useEffect } from 'react';
import type { SecondaryMarketServiceRootResponse } from 'src/apis/secondary-market-service/types';
import { useAxios } from 'src/hooks/use-axios';
import { handleErrorWithNotification } from 'src/utils/handle-error';

export function useSecondaryMarketService() {
  const request = useAxios(
    (axios, baseConfig) =>
      axios.request<SecondaryMarketServiceRootResponse>({
        ...baseConfig,
        url: PRISMA_CONFIG.secondaryMarketService,
      }),
    { neededOnPageLoad: true, cacheKey: 'secondary-market-service-root' }
  );

  useEffect(() => {
    request.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return request;
}

export type SecondaryMarketServiceRequest = ReturnType<
  typeof useSecondaryMarketService
>;

export function useOptionalSecondaryMarketService() {
  const request = useAxios(
    (axios, baseConfig) =>
      axios.request<SecondaryMarketServiceRootResponse>({
        ...baseConfig,
        url: PRISMA_CONFIG.secondaryMarketService,
        timeout: 5000,
      }),
    {
      neededOnPageLoad: true,
      cacheKey: 'secondary-market-service-root',
      onError(error) {
        handleErrorWithNotification({
          error,
          setReauthenticate: () => {},
        });
        return error;
      },
    }
  );

  useEffect(() => {
    request.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return request;
}

export type OptionalSecondaryMarketServiceRequest = ReturnType<
  typeof useOptionalSecondaryMarketService
>;
